import { surfaceVisible, waitForScreen } from './assistantScreen';

export function resultsContext(message) {
  const page = message?.currentPage || 0;
  const loaded = message?.properties?.length || 0;
  const count = Math.max(0, Math.min(6, loaded - page * 6));
  return {
    visible_count: count,
    results_page: page + 1,
    results_start: count ? page * 6 + 1 : 0,
    results_end: count ? page * 6 + count : 0,
    results_has_more: Boolean(message?.hasMore || loaded > (page + 1) * 6),
    results_status: message?.loadingMore ? 'loading' : message?.pageError ? 'error' : count ? 'ready' : 'empty'
  };
}

export function resultsAnnouncement(message) {
  const state = resultsContext(message);
  if (!state.visible_count) return 'No properties matched this search. Would you like to change the filters?';
  const range = state.results_start === state.results_end ? `property ${state.results_start}` : `properties ${state.results_start} through ${state.results_end}`;
  return `Showing ${range}. ${state.results_has_more ? 'Say “next page” for more.' : 'This is the last page.'}`;
}

export async function waitForResults({ getMessage, searchId, page = 0, isCurrent = () => true }) {
  return waitForScreen(() => {
    const message = getMessage();
    if (!message || message.searchId !== searchId || (message.currentPage || 0) !== page || message.loadingMore) return false;
    const count = resultsContext(message).visible_count;
    // An empty API result still waits for the new search to commit to state.
    if (!count) return true;
    return [...document.querySelectorAll('[data-results-search]')].some(element =>
      element.dataset.resultsSearch === String(searchId) && element.dataset.resultsPage === String(page) &&
      surfaceVisible(element) && element.querySelectorAll('[data-result-card]').length === count);
  }, isCurrent, 4000);
}
